/* eslint-disable no-restricted-imports */
import { Box, ButtonBase, Divider, Stack, Typography } from '@mui/material';
import StarsIcon from '@mui/icons-material/Stars';
import {
	AccountSummaryCardPointsButtonBaseSX,
	AccountSummaryCardPointsCardSX,
	AccountSummaryCardPointsContentSX,
	AccountSummaryCardPointsDividerHorizontalSX,
	AccountSummaryCardPointsDividerVerticalSX,
	AccountSummaryCardPointsFrameSX,
	AccountSummaryCardPointsIconSX,
	AccountSummaryCardPointsLabelSX,
	AccountSummaryCardPointsValueSX,
} from '@/components/content/Account/styles/summaryCardPoints';
import { formattingBalancePoints } from 'integration/utils/formattingBalancePoints';

interface AccountSummaryCardPoints {
	type: 'rewards' | 'dpvale';
	balancePoints: string;
	last4Digits: string;
	fullCardNumber: string;
	onCopyCard: (fullCardNumber: string) => void;
}

export const AccountSummaryCardPoints: React.FC<AccountSummaryCardPoints> = ({
	type,
	balancePoints,
	last4Digits,
	// fullCardNumber,
	// onCopyCard,
}) => {
	const isRewards = type === 'rewards';

	const formattedBalancePoints = formattingBalancePoints(balancePoints);

	return (
		<Box sx={AccountSummaryCardPointsFrameSX}>
			<Stack sx={AccountSummaryCardPointsContentSX}>
				<Typography sx={AccountSummaryCardPointsLabelSX}>
					{isRewards ? 'Saldo en puntos rewards' : 'Saldo en dppuntos'}
				</Typography>
				<Typography sx={AccountSummaryCardPointsValueSX(isRewards)}>
					<StarsIcon sx={AccountSummaryCardPointsIconSX} />
					{`${formattedBalancePoints} puntos`}
				</Typography>
			</Stack>
			<Divider orientation="horizontal" flexItem sx={AccountSummaryCardPointsDividerHorizontalSX} />
			<Divider orientation="vertical" flexItem sx={AccountSummaryCardPointsDividerVerticalSX} />
			<Stack sx={AccountSummaryCardPointsContentSX}>
				<Typography sx={AccountSummaryCardPointsLabelSX}>
					{isRewards ? 'Tarjeta Club dp Rewards' : 'Tarjeta dppuntos dpvale'}
				</Typography>
				<Typography sx={AccountSummaryCardPointsCardSX}>
					{`**** **** **** ${last4Digits}`}
					<ButtonBase
						disableRipple
						sx={AccountSummaryCardPointsButtonBaseSX}
						href="/cuenta?tab=clubdp"
					>
						{'Ver más'}
					</ButtonBase>
				</Typography>
			</Stack>
		</Box>
	);
};
